import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { formatErr } from "@/lib/api";
import { Sun, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import heroLandscape from "@/assets/hero-landscape.jpg";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("demo@solarflow.it");
  const [password, setPassword] = useState("demo1234");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Bentornato!");
      nav("/app/dashboard");
    } catch (err) {
      toast.error(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f4f3f0] text-zinc-900 p-3 sm:p-4 flex gap-4">
      {/* Left image panel */}
      <div className="hidden lg:flex relative flex-1 rounded-[28px] overflow-hidden">
        <img src={heroLandscape} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/25 to-black/35" />
        <div className="relative z-10 flex flex-col justify-between p-10 text-white w-full">
          <Link to="/" className="flex items-center gap-2.5 w-max" data-testid="brand-link">
            <div className="w-9 h-9 rounded-xl bg-white flex items-center justify-center text-zinc-900"><Sun size={18} strokeWidth={2.5} /></div>
            <span className="font-semibold text-lg">SolarFlow</span>
          </Link>
          <div>
            <h2 className="text-3xl xl:text-4xl font-semibold leading-[1.15] tracking-tight max-w-md">Disegni il tetto, chiudi il preventivo. Tutto qui.</h2>
            <div className="mt-6 flex flex-wrap gap-2.5">
              {["Simulatore satellitare", "Produzione PVGIS", "Firma online"].map((t) => (
                <span key={t} className="rounded-full border border-white/25 bg-white/10 backdrop-blur-md px-4 py-2 text-sm text-white/90">{t}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Right form */}
      <div className="w-full lg:w-[460px] flex items-center justify-center px-2 sm:px-6 py-8">
        <div className="w-full max-w-sm">
          <Link to="/" className="lg:hidden flex items-center gap-2.5 mb-10">
            <div className="w-10 h-10 rounded-xl bg-zinc-900 flex items-center justify-center text-white"><Sun size={20} strokeWidth={2.5} /></div>
            <span className="font-semibold text-xl">SolarFlow</span>
          </Link>

          <h1 className="text-3xl font-semibold tracking-tight">Bentornato.</h1>
          <p className="text-zinc-500 mt-2 mb-8">Accedi e continua a chiudere preventivi.</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-medium text-zinc-700">Email</label>
              <input
                type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                data-testid="login-email-input"
                className="w-full mt-1.5 rounded-xl border border-zinc-200 bg-white px-4 py-3 text-sm"
              />
            </div>
            <div>
              <label className="text-sm font-medium text-zinc-700">Password</label>
              <input
                type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                data-testid="login-password-input"
                className="w-full mt-1.5 rounded-xl border border-zinc-200 bg-white px-4 py-3 text-sm"
              />
            </div>
            <button
              type="submit" disabled={busy}
              data-testid="login-submit-btn"
              className="w-full bg-zinc-900 text-white font-semibold rounded-full py-3.5 flex items-center justify-center gap-2 hover:bg-zinc-800 active:scale-[0.99] transition-all disabled:opacity-50"
            >
              {busy ? "Accesso…" : "Accedi"} <ArrowRight size={16} />
            </button>
          </form>

          <div className="mt-6 flex items-center justify-between text-sm">
            <Link to="/register" className="text-zinc-500 hover:text-zinc-900 transition-colors" data-testid="register-link">Crea account azienda</Link>
            <Link to="/forgot-password" className="text-zinc-500 hover:text-zinc-900 transition-colors" data-testid="forgot-link">Password dimenticata?</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
